import { Action } from '@ngrx/store';

export enum ActionTypes { 
  REMOVED_REQUIRED_LIST = '[Permission]   REMOVED REQUIRED Request List',
  REMOVED_REQUIRED_LIST_COMPLETE = '[Permission]  REMOVED REQUIRED List Complete',

  PERMISSIONS_LIST = '[Permission]   Permissions Request List',
  PERMISSIONS_LIST_COMPLETE = '[Permission]  Permissions Request  List Complete',

  ALREADY_PERMISSION_SENT_LIST= '[Permission]  Already Permissions Request sent List',
  ALREADY_PERMISSION_SENT_LIST_COMPLETE= '[Permission] Already Permissions Request sent List Complete',

  ALREADY_PERMISSION_APPROVED_LIST= '[Permission]   Permissions approved List',
  ALREADY_PERMISSION_APPROVED_LIST_COMPLETE= '[Permission]   Permissions approved List Complete',

  ALREADY_PERMISSION_APPROVED_LIST_FAILURE = '[Permission]   Permissions approved List Failure',
}   

export class removedRequiredList implements Action {
  readonly type = ActionTypes.REMOVED_REQUIRED_LIST;
}
export class removedRequiredListComplete implements Action {
  readonly type = ActionTypes.REMOVED_REQUIRED_LIST_COMPLETE;
  constructor(public payload: any) {}
}
export class permissions implements Action {
  readonly type = ActionTypes.PERMISSIONS_LIST;
}

export class permissionsComplete implements Action {
  readonly type = ActionTypes.PERMISSIONS_LIST_COMPLETE;
  constructor(public payload: any) {}
}

export class alreadyPermissionsSentList implements Action{
  readonly type=ActionTypes.ALREADY_PERMISSION_SENT_LIST;
}

export class alreadyPermissionsSentListComplete implements Action{
  readonly type=ActionTypes.ALREADY_PERMISSION_SENT_LIST_COMPLETE;
  constructor(public payload: any) {}
}

export class  alreadyPermissionsApprovedList implements Action{
  readonly type=ActionTypes.ALREADY_PERMISSION_APPROVED_LIST;
}

export class  alreadyPermissionsApprovedListComplete implements Action{
  readonly type=ActionTypes.ALREADY_PERMISSION_APPROVED_LIST_COMPLETE;
  constructor(public payload: any) {}
}

export class  alreadyPermissionsApprovedListFailure implements Action{
  readonly type=ActionTypes.ALREADY_PERMISSION_APPROVED_LIST_FAILURE;
  constructor(public payload: any) {}
}



export type Actions =
  | removedRequiredList
  | removedRequiredListComplete
  | permissions
  | permissionsComplete
  | alreadyPermissionsSentList
  | alreadyPermissionsSentListComplete
  | alreadyPermissionsApprovedList
  | alreadyPermissionsApprovedListComplete
  | alreadyPermissionsApprovedListFailure

